import classes from '../styles/Home.module.scss';
import client from './api/graphql';
import { GET_FAQS_CONTENT } from './api/graphql/queries';
import Faqs from '../components/sections/faqs/Faqs.js';

/**
 * Ayoba Web FAQs Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FrequentlyAskedQuestions = (props) => {
    const { faq } = props?.data;

    return (
        <div className={classes.oCampaign}>
            <Faqs {...faq} />
        </div>
    );
};

export async function getServerSideProps(context) {
    const locale = context.query?.lang || context.defaultLocale;

    const { data } = await client.query({
        query: GET_FAQS_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default FrequentlyAskedQuestions;
